import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
export default function MobileHeader ({strikes, setShowHelp}){
    const getStrikes = () => {
            let strikeArray = []
            for (let i = 0; i < 3; i++) {
                if (i < strikes.length) {
                    strikeArray.push(<FontAwesomeIcon icon={["fas", "times"]} size={"xl"} key={i} color="red" />)
                }
                else {
                    strikeArray.push(<FontAwesomeIcon icon={["fas", "times"]} size={"xl"} key={i} color="#ccc" />)
                }
            }
            return <div style={{display:'flex', alignItems:'flex-start', justifyContent:'center'}}>{strikeArray}</div>
        }
    return (
        <header className="App-header" style={{ position: 'sticky', top: 0, zIndex: 50, display:'flex', flexDirection:'column', justifyContent:'center', backgroundColor:'black', borderBottom:'1px solid #ccc', paddingBottom: 8 }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <h1 style={{ cursor: 'default', fontWeight: 'bolder', marginBottom: 0 }}>CineSnake</h1>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '10%', marginTop: 0 }}>
                    {getStrikes()}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '10%', marginTop: 0 }}>
                    <button className='help-button' onClick={() => setShowHelp(true)} style={{ width: 28, height: 28, fontSize: 13 }}>?</button>
                </div>
            </div>
        </header>
    )
}